<!-- day-view.component.html -->
<div class="container-fluid pb-5 desktop-day-view">
        <!-- Page Header with Utility Buttons -->
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
        <h1 class="page-header mb-2 mb-lg-0">Day View</h1>

        <!-- Utility Buttons -->
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
            <!-- Summary Details -->
            <div class="mb-2 mb-md-0 me-md-3">
                <button type="button" class="btn btn-link p-0 text-decoration-none text-reset align-baseline"
                    [matMenuTriggerFor]="summaryBreakdownMenu" title="Show per-instructor breakdown">
                    <span class="d-none d-sm-inline">Overall Summary: </span>
                    <span class="d-sm-none fw-bold">Summary: </span>
                    <span title="Booked Daily">{{ summaryCount.privateLessonDaily }}</span>
                    <sup title="Taken Daily">{{ summaryCount.privateTakenLessonDaily }}</sup>
                    <b> / </b>
                    <span title="Booked Weekly">{{ summaryCount.privateLessonWeekly }}</span>
                    <sup title="Taken Weekly">{{ summaryCount.privateTakenLessonWeekly }}</sup>
                    <span class="mx-1">&bull;</span>
                    <span>Coaching: </span>
                    <span title="Coaching Booked Daily">{{ summaryCoaching.bookedDaily }}</span>
                    <sup title="Coaching Taken Daily">{{ summaryCoaching.takenDaily }}</sup>
                    <b> / </b>
                    <span title="Coaching Booked Weekly">{{ summaryCoaching.bookedWeekly }}</span>
                    <sup title="Coaching Taken Weekly">{{ summaryCoaching.takenWeekly }}</sup>
                    <mat-icon class="menu-dropdown align-middle">arrow_drop_down</mat-icon>
                </button>
                <mat-menu #summaryBreakdownMenu="matMenu">
                    <div class="px-3 py-1" style="min-width: 240px;" (click)="$event.stopPropagation()">
                        <div class="d-flex justify-content-between fw-bold small border-bottom pb-1 mb-1">
                            <span>Category</span>
                            <span>Daily / Weekly</span>
                        </div>
                        <div *ngFor="let row of summaryBreakdown"
                            class="d-flex justify-content-between small py-1">
                            <span class="me-3 text-truncate" style="max-width: 160px;">{{ row.label }}</span>
                            <span class="text-nowrap">
                                <span title="Booked Daily">{{ row.bookedDaily }}</span><sup title="Taken Daily">{{ row.takenDaily }}</sup>
                                <b> / </b>
                                <span title="Booked Weekly">{{ row.bookedWeekly }}</span><sup title="Taken Weekly">{{ row.takenWeekly }}</sup>
                            </span>
                        </div>
                        <div *ngIf="!summaryBreakdown?.length" class="small text-muted py-1">
                            No lessons to summarize.
                        </div>
                    </div>
                </mat-menu>
            </div>

            <!-- Button Group -->
            <div class="d-flex flex-wrap gap-1">

                            <button style="color:#000; background-color: #82CFFD !important; border-color: #82CFFD !important;" mat-flat-button class="btn-color-status-update me-1 mb-1" mat-button
                [matMenuTriggerFor]="updateStatusMenu">
                Status Update
                <mat-icon aria-hidden="false" aria-label="Menu dropdown"
                    class="menu-dropdown">arrow_drop_down
                </mat-icon>
            </button>
            <mat-menu #updateStatusMenu="matMenu">
                <button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateLessonComponent, 'statusFormWithData', {eventData: this.Events} )">Update Lesson</button>
                <button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateGroupLessonComponent, 'statusFormWithData', {eventData: this.Events} )">Update Group Lesson</button>
                <button *ngIf="_permissionsService.canAccess('lessons_edit')" mat-menu-item (click)="openDialog(UpdateServiceComponent, 'statusFormWithData', {eventData: this.Events} )">Update Services</button>
            </mat-menu>

            <button *ngIf="_permissionsService.canAccess('lessons_create')" style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;" mat-flat-button class="me-1 mb-1" mat-button
                [matMenuTriggerFor]="newEventMenu" (menuOpened)="loadCoachingPackages()">
                New Event
                <mat-icon aria-hidden="false" aria-label="Menu dropdown"
                    class="menu-dropdown">arrow_drop_down
                </mat-icon>
            </button>
            <mat-menu #newEventMenu="matMenu">
                <button mat-menu-item
                    (click)="openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create')">
                    Add Lesson
                </button>
                <button mat-menu-item
                    (click)="openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create')">
                    Add Group Lesson
                </button>
                <button mat-menu-item
                    (click)="openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create')">
                    Add Service
                </button>
                <button mat-menu-item
                    (click)="openEntityComponent(EventScheduleEntityComponent, 'events', 'schedules', 'create')">
                    Add Schedule
                </button>
                <button mat-menu-item [matMenuTriggerFor]="coachingMenu">
                    Add Coaching
                </button>
                <button *ngIf="_permissionsService.canAccess('students_create')" mat-menu-item
                    (click)="openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
                        'dayview_field_date_and_time': this.calendarDateInquiry,
                        'inquiry': true
                    })">
                    Add Inquiry
                </button>
            </mat-menu>
            <mat-menu #coachingMenu="matMenu">
                <button mat-menu-item disabled *ngIf="coachingPackagesLoading">Loading…</button>
                <button mat-menu-item disabled *ngIf="!coachingPackagesLoading && coachingPackages.length === 0">No coaching packages</button>
                <button mat-menu-item *ngFor="let coachingPackage of coachingPackages"
                    (click)="openCoachingLesson(coachingPackage, false)">
                    {{ coachingPackage.name }}
                </button>
            </mat-menu>

            <button *ngIf="_permissionsService.canAccess('students_create')" class="me-1 mb-1" style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;" (click)="openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
                'dayview_field_date_and_time': this.calendarDateInquiry,
                'inquiry': true
            })" type="button"
                mat-button>
                Add Inquiry
            </button>

                            <button *ngIf="showPaymentsDueBell && _permissionsService.canAccess('payments_view')"
                type="button"
                mat-icon-button
                class="me-1 mb-1"
                style="background-color: transparent !important; border: none;"
                [matMenuTriggerFor]="paymentsDueMenu"
                [matBadge]="paymentsDueUnpaidCount"
                [matBadgeHidden]="!paymentsDueUnpaidCount"
                matBadgeColor="warn"
                matBadgeSize="small"
                matTooltip="Payments for this day's appointments"
                matTooltipPosition="below"
                aria-label="Day payments">
                <mat-icon [style.color]="paymentsDueUnpaidCount ? '#DAA520' : '#1C3F8B'">payments</mat-icon>
            </button>
            <mat-menu #paymentsDueMenu="matMenu" class="day-payments-menu">
                <ng-template matMenuContent>
                    <div class="px-3 py-2" (click)="$event.stopPropagation()">
                        <div class="fw-bold">Payments</div>
                        <div class="small text-muted">{{ (paymentsDueDate + 'T12:00:00') | date:'EEEE, MMMM d' }}</div>
                        <div class="small text-muted" *ngIf="!paymentsDueLoading">
                            {{ paymentsDueAppointments.length }} appointment{{ paymentsDueAppointments.length === 1 ? '' : 's' }}
                        </div>
                    </div>
                    <mat-divider></mat-divider>

                    <div *ngIf="paymentsDueLoading" class="d-flex align-items-center gap-2 px-3 py-2"
                        (click)="$event.stopPropagation()">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span class="small">Loading…</span>
                    </div>

                    <div *ngIf="!paymentsDueLoading && !paymentsDueAppointments.length" class="px-3 py-2 small text-muted"
                        (click)="$event.stopPropagation()">
                        No appointments this day.
                    </div>

                    <button *ngFor="let appt of paymentsDueAppointments" mat-menu-item
                        style="height: auto; line-height: normal;"
                        (click)="goToPaymentsDueStudent(appt)">
                        <div class="d-flex flex-column py-2" style="min-width: 320px;">
                            <div class="d-flex justify-content-between align-items-baseline gap-3">
                                <span>{{ appt.student_name }}</span>
                                <span class="fw-bold">{{ paymentsDueWithTax(appt.amount, appt.amount_tax) | studioCurrency }}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-baseline gap-3 small">
                                <span class="text-muted">
                                    {{ appt.start | date:'h:mm a' }}<ng-container *ngIf="appt.enrollment_title"> · {{ appt.enrollment_title }}</ng-container>
                                </span>
                                <span [ngClass]="{
                                    'text-danger fw-bold': appt.status === 'Unpaid',
                                    'text-success': appt.status === 'Paid',
                                    'text-muted': appt.status === 'Covered'
                                }">{{ appt.status }}</span>
                            </div>
                            <div *ngIf="appt.past_due" class="small text-danger">
                                Past due {{ paymentsDueWithTax(appt.past_due, appt.past_due_tax) | studioCurrency }}
                            </div>
                        </div>
                    </button>

                    <ng-container *ngIf="paymentsDueAppointments.length">
                        <mat-divider></mat-divider>
                        <div class="px-3 py-2" (click)="$event.stopPropagation()">
                            <div class="d-flex justify-content-between gap-3">
                                <span class="text-muted">Due today</span>
                                <span class="fw-bold">{{ paymentsDueWithTax(paymentsDueTotals.due_today, paymentsDueTotals.due_today_tax) | studioCurrency }}</span>
                            </div>
                            <div *ngIf="paymentsDueShowTax && paymentsDueTotals.due_today_tax" class="text-end small text-muted">
                                includes {{ paymentsDueTotals.due_today_tax | studioCurrency }} tax
                            </div>
                            <div *ngIf="paymentsDueTotals.past_due" class="d-flex justify-content-between gap-3 small text-muted">
                                <span>Past due</span>
                                <span>{{ paymentsDueWithTax(paymentsDueTotals.past_due, paymentsDueTotals.past_due_tax) | studioCurrency }}</span>
                            </div>
                            <div *ngIf="paymentsDueShowTax && paymentsDueTotals.past_due_tax" class="text-end small text-muted">
                                includes {{ paymentsDueTotals.past_due_tax | studioCurrency }} tax
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
            </mat-menu>

                            <button style="background-color: transparent !important; border: none;"
                (click)="openPrintDialog()"
                type="button"
                mat-icon-button
                class="mb-1"
                matTooltip="Print daily attendance sheet for student sign-ins"
                matTooltipPosition="below"
                aria-label="Print attendance sheet">
                <mat-icon style="color: #1C3F8B;">print</mat-icon>
            </button>
            </div>
        </div>
    </div>

    <!-- Filter Form  -->
    <app-day-view-frm-filter #filterComponent (updateCalendarEvents)=updateCalendarEvents($event)
        [filterInstructorCategory]="filterInstructorCategory"
        [filterLessonType]="filterLessonType" [filterStudent]="filterStudent"
        [filterDate]="filterDate" [filterGroupLesson]="filterGroupLesson"
        [filterLesson]="filterLesson" [filterServices]="filterServices"
        [studioCountry]="studioCountry">
    </app-day-view-frm-filter>



    <!-- Hidden instructor toggle that will be moved to header -->
    <div style="display: none;">
        <app-instructor-toggle
            #instructorToggleComponent
            [instructors]="resourcesArray"
            [storageScope]="instructorToggleStorageScope"
            (instructorSelectionChanged)="onInstructorSelectionChanged($event)">
        </app-instructor-toggle>
    </div>

    <div class="mt-4">
        <!-- Loading indicator while timezone loads -->
        <div *ngIf="!studioTimezoneLoaded" class="text-center p-5">
            <mat-spinner class="mx-auto" diameter="50"></mat-spinner>
            <p class="mt-3">Loading calendar...</p>
        </div>

        <!-- Calendar only renders once timezone is loaded -->
        <full-calendar *ngIf="studioTimezoneLoaded" #calendar [options]="calendarOptions"></full-calendar>
    </div>

    <!-- TODO: make this a component -->
    <div *ngIf="_permissionsService.canAccess('lessons_edit')" #customPopover class="popover in bg-transparent border-0 shadow-none" role="tooltip" id="custom-popover" style="display: none;">
        <app-booking-menu
            [canBookLessons]="_permissionsService.canAccess('lessons_create')"
            [canAddInquiry]="_permissionsService.canAccess('students_create')"
            [coachingPackages]="coachingPackages"
            [coachingPackagesLoading]="coachingPackagesLoading"
            [openKey]="bookingMenuOpenKey"
            (choose)="onBookingMenuChoice($event)"
            (coachingChoose)="openCoachingLesson($event, true); hideCustomPopover();"
            (close)="hideCustomPopover()">
        </app-booking-menu>
    </div>

    <!-- TODO: make this a component -->
    <div *ngIf="_permissionsService.canAccess('lessons_edit')" class="popover bottom in" role="tooltip" id="custom-context-menu" style="display: none;">
        <div class="arrow" style="left: 50%;"></div>
        <div class="popover-content">
            <div style="display: grid;">

                <!-- Standing Series Items (Outlook-style) -->
                <ng-container *ngIf="contextMenuStandingSeriesId">
                    <div class="context-menu-item" (click)="openThisEvent()">
                        <mat-icon>event</mat-icon>
                        <div class="context-button">Open This Event</div>
                    </div>
                    <div *ngIf="_permissionsService.canAccess('lessons_edit')" class="context-menu-item" (click)="openSeriesDialog('edit')">
                        <mat-icon>edit</mat-icon>
                        <div class="context-button">Edit Series</div>
                    </div>
                    <hr *ngIf="_permissionsService.canAccess('lessons_cancel')" />
                    <div *ngIf="_permissionsService.canAccess('lessons_cancel')" class="context-menu-item" (click)="deleteThisEvent()">
                        <mat-icon>delete_outline</mat-icon>
                        <div class="context-button">Delete This Event</div>
                    </div>
                    <div *ngIf="_permissionsService.canAccess('lessons_cancel')" class="context-menu-item context-menu-item-warn" (click)="deleteSeriesDialog()">
                        <mat-icon>delete_forever</mat-icon>
                        <div class="context-button">Delete Series</div>
                    </div>
                    <hr />
                </ng-container>

                <!-- Standard Items (always shown) -->
                <div class="context-menu-item">
                    <mat-icon>content_copy</mat-icon>
                    <div (click)="copyClick()" type="button"
                        class="context-button" target_element="lesson"
                        title="Copy">
                        Copy
                    </div>
                </div>

                <div *ngIf="!isEventHidden()" class="context-menu-item">
                    <mat-icon>visibility_off</mat-icon>
                    <div (click)="hideClick()" type="button"
                        class="context-button" target_element="lesson"
                        title="Hide">
                        Hide
                    </div>
                </div>

                <div *ngIf="isEventHidden()" class="context-menu-item">
                    <mat-icon>visibility</mat-icon>
                    <div (click)="unhideClick()" type="button"
                        class="context-button" target_element="lesson"
                        title="Unhide">
                        Unhide
                    </div>
                </div>

                <hr />
                <div class="context-menu-item">
                    <mat-icon>close</mat-icon>
                    <div (click)="closeContextMenu()" type="button"
                        class="context-button"
                        title="Close">
                        Close
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
